import React, { useState } from 'react'
import Icon from 'components/Icon'

const Duration = ({ attribute, state, onChange }) => {
  const { key, name, options, disabled } = attribute

  return (
    <fieldset className="space-y-1">
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <div className="space-x-4">
        { options.map(({ value, label }) => (
          <label key={value}>
            <input
              type="radio"
              disabled={disabled}
              value={value}
              checked={state == value}
              onChange={({ target }) => onChange(target.value)}
              className="mr-1"
            />
            { label }
          </label>
        )) }
      </div>

    </fieldset>
  )
}

export default Duration
